import { egreso as imgEgreso, compactar as imgCompactacion, cambiarEstado as imgCambiarEstado } from '../../../utils/icons';

function ModalImagenInfo({ caso, onClose }) {

    const imagenes = {
        egreso: imgEgreso,
        compactacion: imgCompactacion,
        cambiarEstado: imgCambiarEstado,
    };

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
            onClick={onClose}
        >
            <div
                className="relative w-[50rem] bg-white p-6 rounded-lg shadow-lg"
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    onClick={onClose}
                    className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
                >
                    ✕
                </button>
                <img
                    src={imagenes[caso]}
                    alt={`Información ${caso}`}
                />
            </div>
        </div>
    );
}

export default ModalImagenInfo;